// extracted by mini-css-extract-plugin
export default {"column__container":"BoardCreated_column__container__9T8jq"};